import type { FaireProductEntity } from "../../entity_types/product";

export const p_mccfv8byqk: FaireProductEntity = {
  token: "p_mccfv8byqk",
  type: "product",
  name: "Newborn Knotted Gown - Bliss",
  brandToken: "b_qba2f8n5gh",
  brandName: "Copper Pearl",
  imageUrl:
    "https://cdn.faire.com/fastly/848ed8a5d7824d2a096284bc586b8be2118b400b09d8e2641fa05a492829929e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f187eb322559d9b0e10fa47046fbf26f2a1a2567f59fa212c374ba196728f1c8.jpeg",
    "https://cdn.faire.com/fastly/9386063d88e85923d77aa9b18d05a9bf8c56f8f29005e97eecae89bb699dc3f5.jpeg",
    "https://cdn.faire.com/fastly/be947f0489443a2fc7d6961fa0671ce7cdaf8ee1dbf789d85f4250878f5a5823.jpeg",
    "https://cdn.faire.com/fastly/ce1be8748d17cefdb53556b3e67d6b110e0a07788d377f17ce60756dc6a75213.jpeg",
    "https://cdn.faire.com/fastly/2235c79049bdaa846e15191be48fc6ba912ad0334798e69f5fcc2110d7c30a83.jpeg",
  ],
  priceDollars: 14,
  description:
    "* \nPREMIUM POLYESTER/RAYON BLEND – Made with the same premium knit fabric as our beloved swaddles, this soft and stretchy gown ties at the bottom for easy diaper changes—and has room to grow.\n\n * GENEROUS SIZE – A knotted length of 25 inches and width of 8 inches. \n * \nBONUS FEATURES – Our knotted gowns feature unique snaps to make dressing a breeze, along with fold-over hand mitts to prevent scratching.\n\n * \nTRENDY, HIGH QUALITY DESIGNS – At Copper Pearl we pride ourselves on making high quality products that always look great on babies, moms, or in your nursery. Our knotted gowns are simple, modern, and sure to elevate any baby’s style.\n\n * \nPAIR PERFECTLY WITH COPPER PEARL PRODUCTS – Our trendy, newborn knotted gowns flaunt your favorite Copper Pearl prints and patterns. They are made to coordinate perfectly with products you already own and love!",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:14.539Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
